import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './MovuRobotics.frontend.types'

@Injectable({ providedIn: 'root' })
export class MovuRobotics_send_alert_to_footprint_legacyService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { alertMessage: string, alertDetails: string }): Promise<void> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.alertMessage)) {
      $missingRequiredInParams.push('\'alertMessage\'');
    }
    if (isNil($inParams.alertDetails)) {
      $missingRequiredInParams.push('\'alertDetails\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

